// Above the eligibility checklist on every portal page while the company's
// products are off the site: Aldoo's hold (with "See why" when Aldoo gave a
// reason), or the company's own switch, with the way back to it.
import React, { useState } from "react"
import Modal from "aldoo-ra/Modal"
import { NoSymbolIcon, EyeSlashIcon } from "@heroicons/react/24/outline"
import usePortalTexts from "./texts/usePortalTexts"
import { PORTAL } from "./texts/bundles"

export default function CatalogHoldNotice({ org, onOpenSettings }) {
  const t = usePortalTexts(PORTAL)
  const [why, setWhy] = useState(false)
  if (org?.productsHidden !== true) return null

  if (org.productsHiddenBy !== "admin") {
    return (
      <div className="rounded-lg border border-admin_bordered bg-admin_neutral_1/60 px-4 py-3 text-sm flex items-center gap-3" data-testid="catalog-hidden-notice">
        <EyeSlashIcon className="w-5 h-5 shrink-0 text-admin_text_secondary" />
        <span className="flex-1 min-w-0 font-semibold">{t`Your products are hidden from the site`}</span>
        {onOpenSettings && (
          <button type="button" onClick={onOpenSettings} className="underline underline-offset-2 shrink-0" data-testid="catalog-hidden-settings">
            {t`Settings`}
          </button>
        )}
      </div>
    )
  }

  const reason = String(org.productsHiddenReason || "").trim()
  return (
    <div className="rounded-lg border border-admin_error/40 bg-admin_error/5 px-4 py-3 text-sm flex items-center gap-3" data-testid="catalog-hold-notice">
      <NoSymbolIcon className="w-5 h-5 shrink-0 text-admin_error" />
      <span className="flex-1 min-w-0">
        <span className="font-semibold">{t`Your products catalog is put on hold by Aldoo.`}</span>
        {/* no reason given: nothing to see */}
        {reason && (
          <button type="button" onClick={() => setWhy(true)} className="ml-2 underline underline-offset-2 text-admin_error" data-testid="catalog-hold-why">
            {t`See why`}
          </button>
        )}
      </span>
      {why && (
        <Modal isOpen onClose={() => setWhy(false)} title={t`Why your catalog is on hold`} className="max-w-[560px]">
          <div className="p-1 flex flex-col gap-3" data-testid="catalog-hold-reason">
            <div className="text-sm whitespace-pre-line">{reason}</div>
            <div className="text-xs text-admin_text_secondary">{t`Your products are not shown or sold until Aldoo lifts the hold.`}</div>
          </div>
        </Modal>
      )}
    </div>
  )
}
